module.exports = __webpack_public_path__ + "img/snorkeling-4.dea6479d.png";